// App.js - Main App Component with Password Protection
import React, { useEffect, useState } from 'react';
import { RefreshCw } from 'lucide-react';
import LoginScreen from './components/LoginScreen';
import AccessDashboard from './components/AccessDashboard';
import { AUTH_CONFIG } from './config/auth';
import { authUtils } from './utils/authUtils';

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Check authentication status on app load
  useEffect(() => {
    const checkAuth = () => {
      const authenticated = authUtils.isAuthenticated();
      setIsAuthenticated(authenticated);
      setIsLoading(false);
    };

    // Small delay to prevent flash
    setTimeout(checkAuth, 500);
  }, []);

  const handleLogin = () => {
    authUtils.login();
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    authUtils.logout();
    setIsAuthenticated(false);
  };

  // Show loading spinner during auth check
  if (isLoading) {
    return (
        <div style={{
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #0f172a 0%, #1e1b4b 50%, #0f172a 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <RefreshCw size={32} style={{ color: '#a855f7', animation: 'spin 1s linear infinite' }} />
          <style>
            {`
            @keyframes spin {
              from { transform: rotate(0deg); }
              to { transform: rotate(360deg); }
            }
          `}
          </style>
        </div>
    );
  }

  // Show login screen if not authenticated
  if (!isAuthenticated) {
    return (
        <LoginScreen
            onLogin={handleLogin}
            staticPassword={AUTH_CONFIG.STATIC_PASSWORD}
        />
    );
  }

  // Show main dashboard if authenticated
  return <AccessDashboard onLogout={handleLogout} />;
};

export default App;